import axios from 'axios';
import anti_shake from './anti_shake';
// import store from '../../store/index'

export function request(config) {
  // 1.create axios instance
  const instance = axios.create({
    baseURL: 'https://ngdc.cncb.ac.cn/', // 这里不能再加ascancer了，因为后端路由已经加了
    timeout: 100000,
  });

  // 2.axios interceptors
  // 2.1.request interceptor
  instance.interceptors.request.use(config => {

    //注意要把axios也传进去  cancelToken 要用到 axios创建实例
    anti_shake(config, axios); // network request anti-shake

    // config.cancelToken = new axios.CancelToken(cancel => {
    //   store.commit('pushToken', {
    //     cancelToken: cancel
    //   })
    // });
    return config
  }, error => {
    return Promise.reject(error);
  })

  // 2.2.response interceptor
  instance.interceptors.response.use(res => {
    return Promise.resolve(res.data)
  }, error => {
    if (axios.isCancel(error)) { // cancel request, terminate Promise call chain
      return new Promise(() => { });
    } else {
      return Promise.reject(error);
    }
  })

  // 3.send network request
  return instance(config)
}